import React, { useEffect, useRef, useState } from "react"
import { Alert } from "reactstrap"
import { daysLabel, otherName } from "./plannerLabels"
import PlannerDialog from "./PlannerDialog"
import WarningRow from "./WarningRow"

// What lets an acknowledged warning count again (the facts of its fingerprint, Phases A5 and B2).
const PAIR = "It comes back by itself if the dates, the club or the play mode of either tournament change"
const LAPSES = {
  sameArea: `${PAIR}, or the shared levels change.`,
  nationalOverlap: `${PAIR}.`,
  organizerBusy: `${PAIR}, or the organizer changes.`,
  clubBusy: `${PAIR}, or the shared levels, the same organizer or a national overlap change.`,
  possibleDuplicate: `${PAIR}, or the shared levels, the same organizer or a national overlap change.`,
  datesVsPlayMode: "It comes back by itself if the dates or the play mode change.",
}
const MAX_NOTE = 500

// "Acknowledge this warning?" (ticket 13 Q10): a SuperAdmin accepts one warning with an optional note. It covers both proposals of a
// pair and goes into both histories. The page gives the warning as the calendar reads it now; `onConfirm(note)` answers the command's
// result, and a refusal is shown here.
export default function AcknowledgeDialog({ item, warning, timeZone, onClose, onConfirm }) {
  const [note, setNote] = useState("")
  const [state, setState] = useState({})
  // Closed while its command runs: the result reaches the page, not this dialog.
  const open = useRef(true)
  useEffect(() => () => { open.current = false }, [])
  const coversPair = warning.other?.kind === "proposal"
  const scope = coversPair
    ? `It turns grey on ${item.number} and on ${otherName(warning.other)}, leaves their card counts and the With warnings queue, and goes into both histories.`
    : `It turns grey on ${item.number}, leaves its card count and the With warnings queue, and goes into its history.`
  const lapse = warning.rule === "holiday" ? `It comes back by itself if the dates of ${item.number} change.` : LAPSES[warning.rule] || `${PAIR}.`
  const acknowledge = async () => {
    setState({ pending: true })
    const result = await onConfirm(note.trim())
    if (open.current && result?.status !== "saved") setState({ error: result?.message || "The acknowledgement was not confirmed. The calendar is read again: check it." })
  }
  return <PlannerDialog title="Acknowledge this warning?" sub={`${item.number} · ${item.name || "No name yet"} · ${daysLabel(item.days)}`}
    dirty={Boolean(note.trim()) && !state.pending} onClose={onClose}
    actions={<button type="button" className="btn btn-primary" disabled={state.pending} onClick={acknowledge}>{state.pending ? "Acknowledging…" : "Acknowledge"}</button>}>
    <WarningRow warning={warning} timeZone={timeZone} />
    <p className="mb-0">{scope}</p>
    <div className="ep-field">
      <label htmlFor="ep-acknowledge-note">Note (optional)</label>
      <textarea id="ep-acknowledge-note" className="form-control" rows={3} maxLength={MAX_NOTE} value={note} onChange={event => setNote(event.target.value)}
        placeholder="e.g. Both clubs fill their draws separately every year" />
    </div>
    <p className="ep-meta mb-0">{lapse}</p>
    {state.error && <Alert color="danger" className="mb-0">{state.error}</Alert>}
  </PlannerDialog>
}
